function computeEasterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
}
export function getCzechHolidays(year) {
    var easter = computeEasterSunday(year);
    var goodFriday = new Date(easter);
    goodFriday.setDate(easter.getDate() - 2);
    var easterMonday = new Date(easter);
    easterMonday.setDate(easter.getDate() + 1);
    return [
        { date: new Date(year, 0, 1), code: "NEW_YEAR" },
        { date: goodFriday, code: "GOOD_FRIDAY" },
        { date: easterMonday, code: "EASTER_MONDAY" },
        { date: new Date(year, 4, 1), code: "LABOUR_DAY" },
        { date: new Date(year, 4, 8), code: "VICTORY_DAY" },
        { date: new Date(year, 6, 5), code: "CYRIL_METHODIUS" },
        { date: new Date(year, 6, 6), code: "JAN_HUS" },
        { date: new Date(year, 8, 28), code: "ST_WENCESLAS" },
        { date: new Date(year, 9, 28), code: "INDEPENDENT_CZ" },
        { date: new Date(year, 10, 17), code: "FREEDOM_DAY" },
        { date: new Date(year, 11, 24), code: "CHRISTMAS_EVE" },
        { date: new Date(year, 11, 25), code: "CHRISTMAS_DAY" },
        { date: new Date(year, 11, 26), code: "ST_STEPHEN" },
    ];
}
export function isCzechHoliday(date) {
    return getCzechHolidays(date.getFullYear()).find(function (h) {
        return h.date.getFullYear() === date.getFullYear() &&
            h.date.getMonth() === date.getMonth() &&
            h.date.getDate() === date.getDate();
    });
}
